import { useToken } from "@chakra-ui/react";
import { Row, RowData } from "@tanstack/react-table";
import type { ComponentProps } from "components/Shared/ChakraReactTable";

function defaulGetIsArchived<TData extends RowData = unknown>(row: Row<TData>) {
  if (
    !row.original ||
    typeof row.original !== "object" ||
    !("isArchived" in row.original) ||
    typeof row.original.isArchived !== "boolean"
  )
    return;
  return row.original.isArchived;
}

export default function useArchivedRowProps<D>(
  getIsArchived: (row: Row<D>) => boolean | undefined = defaulGetIsArchived,
): ComponentProps<D> {
  const [gray400] = useToken("colors", ["gray.400"]);
  return {
    getRowProps: (row) => ({
      sx: {
        "&[data-archived=true]": {
          color: "gray.400",
          ".chakra-link": { color: "gray.400" },
          ".chakra-badge, .chakra-tag": {
            "--badge-color": gray400,
          },
        },
      },
      "data-archived": getIsArchived(row),
    }),
  };
}
